import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossip";

const deepArticles = articles.filter((item) => item.deep).slice(0, 3);

export default function DeepSection() {
  return (
    <section className="w-full bg-secondary-950 py-14 md:py-20" aria-labelledby="deep-heading">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.2em] text-accent-400 uppercase mb-2">
              Deep Dive
            </p>
            <h2 id="deep-heading" className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
              深水硬核专区：把时间线一次讲透
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-300/90 leading-relaxed">
              这类内容不适合几句话带过。我们把公开信息按时间顺序摊开，标注每一步的出处，让你自己判断事件是怎么一步步走到今天的。
            </p>
          </div>
          <Link
            to="/hot?category=screen"
            className="inline-flex items-center gap-1.5 text-sm font-label font-medium text-accent-300 hover:text-accent-200 transition-colors whitespace-nowrap shrink-0 cursor-pointer"
          >
            更多硬核整理
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {deepArticles.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col bg-secondary-900 border border-secondary-800 rounded-lg overflow-hidden hover:border-accent-500/60 transition-colors"
            >
              <Link to={`/hot/${item.id}`} className="block w-full h-44 overflow-hidden cursor-pointer" aria-label={item.title}>
                <img
                  src={item.cover}
                  alt={`${item.title}配图`}
                  title={`${item.title} - 看料吃瓜深水硬核`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </Link>
              <div className="flex flex-col flex-1 p-5">
                <span className="inline-flex items-center gap-1.5 text-[11px] font-label text-accent-300 bg-accent-500/15 px-2 py-0.5 rounded-full w-fit mb-3">
                  <i className="ri-focus-3-line"></i>
                  {item.categoryLabel} · 硬核
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 leading-snug mb-4">
                  <Link to={`/hot/${item.id}`} className="hover:text-accent-300 transition-colors cursor-pointer">
                    {item.title}
                  </Link>
                </h3>

                <ol className="space-y-3 mb-4">
                  {item.timeline.slice(0, 3).map((step) => (
                    <li key={step.time} className="flex gap-3">
                      <span className="flex flex-col items-center shrink-0 pt-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                        <span className="w-px flex-1 bg-secondary-700"></span>
                      </span>
                      <span className="text-xs leading-relaxed">
                        <span className="font-label text-accent-300 mr-2">{step.time}</span>
                        <span className="text-background-300/90">{step.event}</span>
                      </span>
                    </li>
                  ))}
                </ol>

                <Link
                  to={`/hot/${item.id}`}
                  className="mt-auto inline-flex items-center gap-1.5 text-xs font-label text-background-200 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  查看完整时间线
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}